var _path, _rect, _rect2, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.10742C17.5 6.11228 15.9206 7.71484 14 7.71484C12.0794 7.71484 10.5 6.11228 10.5 4.10742C10.5 2.10255 12.0794 0.5 14 0.5C15.9206 0.5 17.5 2.10255 17.5 4.10742Z",
    stroke: "#00A651"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 9.78516,
    width: 8.21477,
    height: 8,
    rx: 1,
    transform: "rotate(90 18 9.78516)",
    fill: "#2A2D34"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.47058,
    y: 13.5908,
    width: 4.34899,
    height: 8.47059,
    rx: 1,
    transform: "rotate(90 8.47058 13.5908)",
    fill: "#2A2D34"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.47058,
    y: 9.78516,
    width: 3.26174,
    height: 8.47059,
    rx: 1,
    transform: "rotate(90 8.47058 9.78516)",
    fill: "#00A651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 -1.74846e-07C6.20914 -7.8281e-08 8 1.79086 8 4L8 8.21477L4 8.21477C1.79086 8.21477 -1.23447e-06 6.4239 -1.13791e-06 4.21477L-9.53674e-07 -3.49691e-07L4 -1.74846e-07Z",
    fill: "#2A2D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.ec06260096d5bbdf7e9c7171517fe778.svg";
export { ForwardRef as ReactComponent };